export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/FreeInitiatives.886f5439.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};